// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  systemConfigList:[],
  systemConfigPage:1,
  systemConfigSize:10,
  systemConfigTotal:0,
  systemConfigById:{},
  systemConfigModalType:"create",
  systemConfigModalVisible:false,
  currentSystemConfig:{},
  getSystemConfigListPending: false,
  getSystemConfigListError: null,
  submitSystemConfigPending: false,
  submitSystemConfigError: null,
  deleteSystemConfigPending: false,
  deleteSystemConfigError: null,
  systemConfigTypeList:[],
  getgetDictionariesMap:{},
  systemConfigTypePage:1,
  systemConfigTypeSize:10,
  systemConfigTypeTotal:0,
  systemConfigTypeById:{},
  allConfigList:[],
  allConfigType:{},
  systemConfigTypeModalType:"create",
  systemConfigTypeModalVisible:false,
  currentSystemConfigType:{},
  getSystemConfigTypeListPending: false,
  getSystemConfigTypeListError: null,
  submitSystemConfigTypePending: false,
  submitSystemConfigTypeError: null,
  deleteSystemConfigTypePending: false,
  deleteSystemConfigTypeError: null,
  getAllConfigTypePending: false,
  getAllConfigTypeError: null,
  getAllSystemConfigPending: false,
  getAllSystemConfigError: null,
  tagSystemConfigById:{},
  tagSystemConfigList:{},
  getDictionariesListPending: false,
  getDictionariesListError: null,
  getDictionariesLists:{},
  getDictNameListPending: false,
  getDictNameListError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/initialState.js